import isBrowser from "./isBrowser";

 const getStaticUrl = (url:string) => isBrowser ? location.origin + url : ''

 export default getStaticUrl